import { IPayoutTransfer } from "../../../services/api/payments/payouts/types";

export const getTotalTransfersAmount = (
  transfers: IPayoutTransfer[]
): number => {
  return transfers.reduce((total, transfer) => total + transfer.amount, 0);
};
